exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".vertical-list{flex-flow:column;display:flex}.vertical-list li{list-style-type:none}.vertical-list>*{display:block;margin-top:2px;margin-bottom:2px}.horizontal-list>*{margin-left:2px;margin-right:2px;display:inline-block;vertical-align:top}.horizontal-list{display:flex;align-items:flex-start;overflow:auto;white-space:nowrap}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/styles/Form_layout.css
// module id = 308
// module chunks = 1 2 3 4 5 7